<template>
  <div class="versions">
    <div class="btn-box">
      <div class="total-box">
        <p>
          查询日期总质检数：<span style="color: red">{{
            allQuality.todayAll
          }}</span>
        </p>
        <p>
          总质检数：<span style="color: #0000ff">{{ allQuality.all }}</span>
        </p>
      </div>
      <el-button class="add-btn" @click="add" icon="el-icon-plus"
        >添加质检员</el-button
      >
    </div>

    <div class="top">
      <div class="querybox">
        <div>
          <p>质检员账号：</p>
          <el-input
            v-model="queryParams.qualityTestingAccount"
            placeholder="请输入质检员账号"
            clearable
          ></el-input>
        </div>
        <div>
          <p>质检员名字：</p>
          <el-input
            v-model="queryParams.qualityTestingName"
            placeholder="请输入质检员名字"
            clearable
          ></el-input>
        </div>
        <div>
          <p>日期选择：</p>
          <el-date-picker
            v-model="dateValue"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            :default-time="['00:00:00', '23:59:59']"
            @change="timeChange"
          >
          </el-date-picker>
        </div>
      </div>
      <div class="handlebox">
        <div class="btnbox">
          <el-button
            type="primary"
            icon="el-icon-refresh-right"
            class="reset-btn"
            @click="resetFn"
            >重置</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-search"
            class="search-btn"
            @click="search"
            >查询</el-button
          >
        </div>
      </div>
    </div>
    <div class="content">
      <el-table
        :data="tableData"
        tooltip-effect="dark"
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ 'text-align': 'center' }"
      >
        <el-table-column
          prop="qualityTestingAccount"
          label="质检员账号"
        ></el-table-column>
        <el-table-column prop="qualityTestingName" label="质检员名字">
        </el-table-column>
        <el-table-column prop="qualityTestingCode" label="质检码">
        </el-table-column>
        <el-table-column prop="todayQualityTestingNum" label="查询日期质检数">
          <template slot-scope="{ row }">
            <p style="color: red">{{ row.todayQualityTestingNum }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="totalQualityTestingNum" label="总质检数">
          <template slot-scope="{ row }">
            <p style="color: #0000ff">{{ row.totalQualityTestingNum }}</p>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="updateType" label="状态">
          <template slot-scope="{ row }">
            <el-button class="green-btn" v-if="row.isDel === 0">正常</el-button>
            <el-button class="red-btn" v-else>已删除</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="url" label="操作">
          <template slot-scope="{ row }">
            <el-popconfirm
              title="是否删除该质检员？"
              popper-class="customerdel-popover"
              @confirm="deleteStaff(row.id)"
              v-if="Number(row.isDel) === 0"
            >
              <el-button class="textOrange-btn" slot="reference"
                >删除</el-button
              >
            </el-popconfirm>
          </template>
        </el-table-column> -->
      </el-table>
      <!-- 分页组件 -->
      <pagination
        v-show="total > queryParams.pageSize"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="init"
      />
    </div>
    <!-- 添加质检员 -->
    <el-dialog
      :visible.sync="descriptionVisible"
      title="添加质检员"
      :before-close="handleClose"
      destroy-on-close
      :show-close="false"
      width="40%"
    >
      <div slot="title" class="title">
        <p>添加质检员</p>
        <span @click="handleClose"><i class="el-icon-close"></i></span>
      </div>
      <div class="agree-content">
        <el-form
          :model="staffForm"
          :rules="staffRules"
          ref="staffForm"
          class="demo-staffForm"
          label-position="left"
          label-width="120px"
        >
          <el-form-item label="质检员账号：" prop="qualityTestingAccount">
            <el-input
              v-model="staffForm.qualityTestingAccount"
              placeholder="请输入质检员账号"
            ></el-input>
          </el-form-item>
          <el-form-item label="质检员名字：" prop="qualityTestingName">
            <el-input
              v-model="staffForm.qualityTestingName"
              placeholder="请输入质检员名字"
            ></el-input>
          </el-form-item>
          <el-form-item label="质检码(密码)：" prop="qualityTestingCode">
            <el-input
              v-model="staffForm.qualityTestingCode"
              placeholder="请输入质检码(密码)"
            ></el-input>
          </el-form-item>
          <el-form-item class="handlebox">
            <el-button
              type="primary"
              @click="submitForm('staffForm')"
              class="enter-btn save-btn"
              :loading="submitLoading"
              >保存</el-button
            >
            <el-button
              @click="resetForm('staffForm')"
              class="cancel-btn calloff-btn"
              >取消</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getStaffList,
  addStaff,
  getDeleteStaff,
  getCountAllQuality,
} from "@/api/device";
export default {
  data() {
    return {
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        qualityTestingName: "",
        qualityTestingAccount: "",
        qualityTestingEndTime: this.$moment()
          .endOf("day")
          .format("YYYY-MM-DD HH:mm:ss"),
        qualityTestingStartTime: this.$moment()
          .startOf("day")
          .format("YYYY-MM-DD HH:mm:ss"),
      },
      tableData: [],
      total: 0, //总数
      descriptionVisible: false,
      description: "",
      staffForm: {
        qualityTestingAccount: "",
        qualityTestingCode: "",
        qualityTestingName: "",
      },
      staffRules: {
        qualityTestingAccount: [
          { required: true, message: "请输入质检员账号", trigger: "blur" },
          {},
        ],
        qualityTestingCode: [
          { required: true, message: "请输入质检码", trigger: "blur" },
          {},
        ],
        qualityTestingName: [
          { required: true, message: "请输入质检员名字", trigger: "blur" },
          {},
        ],
      },
      submitLoading: false,
      allQuality: { all: 0, todayAll: 0 },
      dateValue: "",
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    //获取质检员列表
    async init() {
      const res = await getStaffList(this.queryParams);
      const params = {
        qualityTestingEndTime: this.queryParams.qualityTestingEndTime,
        qualityTestingStartTime: this.queryParams.qualityTestingStartTime,
      };
      const res1 = await getCountAllQuality(params);
      // console.log(res1);
      this.tableData = res.result.records;
      this.total = res.result.total;
      this.allQuality = res1.result;
    },
    handleClose() {
      this.descriptionVisible = false;
    },
    // 添加
    add() {
      this.descriptionVisible = true;
    },
    // 新建质检员
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.submitLoading = true;
          const params = this.staffForm;
          await addStaff(params);
          this.$message.success("添加成功！");
          this.submitLoading = false;
          this.resetForm(formName);
          this.resetFn();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      // console.log(formName);
      this.$refs[formName].resetFields();
      this.handleClose();
    },
    // 查询
    search() {
      this.queryParams.pageNum = 1;
      this.init();
    },
    //重置
    resetFn() {
      this.queryParams.qualityTestingAccount = "";
      this.queryParams.qualityTestingName = "";
      this.queryParams.pageNum = 1;
      this.dateValue = "";
      this.queryParams.qualityTestingEndTime = this.$moment()
        .endOf("day")
        .format("YYYY-MM-DD HH:mm:ss");
      this.queryParams.qualityTestingStartTime = this.$moment()
        .startOf("day")
        .format("YYYY-MM-DD HH:mm:ss");
      this.init();
    },
    // 编辑
    async deleteStaff(id) {
      await getDeleteStaff({ id });
      this.$message.success("删除成功！");
      this.search();
      // console.log(row);
    },
    timeChange(event) {
      // console.log(event);
      if (event) {
        this.queryParams.qualityTestingStartTime = this.$moment(
          event[0]
        ).format("YYYY-MM-DD HH:mm:ss");
        this.queryParams.qualityTestingEndTime = this.$moment(event[1]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
      } else {
        this.queryParams.qualityTestingStartTime = "";
        this.queryParams.qualityTestingEndTime = "";
      }
      // console.log(this.queryParams);
    },
  },
};
</script>
<style lang="scss" scoped>
.versions {
  position: relative;
  .top {
    display: flex;
    justify-content: space-between;
    padding-bottom: 32px;
    ::v-deep .querybox {
      display: flex;
      align-items: center;
      width: 0;
      flex: 1;
      justify-content: space-around;
      > div {
        display: flex;
        align-items: center;
        padding-right: 20px;
        p {
          font-weight: 400;
          font-size: 14px;
          color: #262626;
          line-height: 20px;
          white-space: nowrap;
        }
        // display: flex;
        // align-items: center;
        // margin-right: 24px;

        // .el-input {
        //   width: 180px;
        // }
        // input::-webkit-input-placeholder {
        //   /* WebKit browsers */
        //   color: rgba(0, 0, 0, 0.25);
        // }
        // .el-input__inner {
        //   background: #ffffff;
        //   border-radius: 4px;
        //   border: 1px solid #d9d9d9;
        // }
      }
    }
    .handlebox,
    .btnbox {
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
    }
  }
  .btn-box {
    position: absolute;
    top: -88px;
    right: 0;
    display: flex;
    align-items: center;
    .total-box {
      display: flex;
      align-items: center;
      margin-right: 90px;
      p {
        font-size: 16px;
        display: flex;
        align-items: flex-end;
        margin-right: 40px;
        span {
          display: inline-block;
          font-size: 22px;
          font-weight: bold;
        }
      }
    }
  }
  ::v-deep(.el-dialog) {
    .el-dialog__body {
      display: flex;
      align-items: center;
      justify-content: center;
      .agree-content {
        width: 100%;
        display: flex;
        justify-content: center;
      }
      .OutBtnBox {
        margin-top: 10px;
        text-align: center;
      }
    }
  }
  ::v-deep .demo-staffForm {
    width: 80%;
    .el-form-item {
      display: flex;
      align-items: center;
    }
    .el-form-item__label {
      white-space: nowrap;
      min-width: 120px !important;
      font-weight: 400;
      font-size: 14px;
      color: #262626;
    }
    .el-form-item__content {
      width: 0;
      flex: 1;
      margin: 0 !important;
    }
    .handlebox {
      text-align: right;
      margin-top: 50px;
    }
    // .el-input {
    //   width: 380px;
    // }
  }
  .textOrange-btn {
    padding: 0 5px;
  }
}
</style>
